import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

const auth: {
    [key: string]: {
        read: boolean;
        write: boolean;
    };
} = {
    Dashboard: {
        read: true,
        write: true,
    },
    Equipements: {
        read: true,
        write: true,
    },
    Notifications: {
        read: true,
        write: true,
    },
    Rapport: {
        read: true,
        write: true,
    },
    Labo: {
        read: true,
        write: true,
    },
    Securite: {
        read: true,
        write: true,
    },
    AccesInternet: {
        read: true,
        write: true,
    },
    Parametre: {
        read: true,
        write: true,
    },
};

type PathParams = {
    pathname: string;
};

interface Props extends RouteComponentProps<PathParams> {
    type: 'read' | 'write';
    page?: string;
    children: JSX.Element | JSX.Element[];
    data?: any
}

class Authorization extends React.Component<Props> {
    // Calcule a chaque rendu : le droit depend de l'URL et des roles, qui
    // peuvent arriver apres le montage du composant.
    checkAuthorizations = () => {
        const { type, page, data, location } = this.props;
        const pageName = page ? page : location.pathname.replace(/[/]/g, '');
        const authorization = data ? data[pageName] : auth[pageName];
        return authorization ? authorization[type] : false;
    };

    render() {
        const { children } = this.props;
        if (this.checkAuthorizations()) {
            return children;
        } else {
            return <div className={'d-none'} />;
        }
    }
}

export default withRouter(Authorization);